const EPN_DLIST_SET_LOADING = 'EPN_DLIST_SET_LOADING';
const EPN_DLIST_SET_DATA = 'EPN_DLIST_SET_DATA';
const EPN_DLIST_SET_ERROR = 'EPN_DLIST_SET_ERROR';
const EPN_DLIST_CLEAR_DATA = 'EPN_DLIST_CLEAR_DATA';

export default {
  EPN_DLIST_SET_LOADING,
  EPN_DLIST_SET_DATA,
  EPN_DLIST_SET_ERROR,
  EPN_DLIST_CLEAR_DATA
};
